/**
 * Hook: single source of truth for current language and changing it.
 * Use this instead of local lang/setLang state so i18n stays in sync with UI and storage.
 */
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "./config";

export function useLanguage() {
  const { i18n } = useTranslation();
  const language = i18n.language || i18n.options.fallbackLng;

  const setLanguage = useCallback(
    (lng) => {
      if (!lng || !i18n.options.supportedLngs?.includes(lng)) return;
      i18n.changeLanguage(lng);
      try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
        localStorage.setItem("LANGUAGE", JSON.stringify(lng));
      } catch (_) {}
    },
    [i18n]
  );

  const normalized = language?.split("-")[0];
  return {
    language: normalized && SUPPORTED_LANGUAGES.includes(normalized) ? normalized : DEFAULT_LANGUAGE,
    setLanguage,
  };
}
